<app-content-block
  *ngIf="blocks"
  [blocks]="blocks"
  [environmentJSON]="environmentJSON">
</app-content-block>
